/*
# Frontend JS | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadI18n
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
# created 2026-03-15 by Codex
# last edited 2026-03-15 by Codex // add dedicated translations for the visitor lead module
*/
const translations = {
  en: {
    'view.title': 'Record booth visit',
    'common.loading': 'Loading',
    'scan.activeLogin': 'Active scan login',
    'scan.switchCamera': 'Switch camera',
    'scan.chooseLoginTitle': 'Choose scan login',
    'scan.chooseLoginText': 'First choose the event and visitor ticket that should be used to capture leads.',
    'scan.takePhoto': 'Take ticket photo',
    'scan.captureHint': 'Apple currently does not allow stable live scanning inside installed iOS web apps. A photo is captured and analyzed locally instead.',
    'scan.liveUnavailable': 'The live scanner could not be started.',
    'scan.noActiveLogin': 'No active scan login',
    'scan.unknownUser': 'Unknown user',
    'scan.noFair': 'No event',
    'scan.offlineStoredTitle': 'Saved offline',
    'scan.offlineStoredText': 'The contact was stored locally and will be synchronized later.',
    'scan.leadCapturedTitle': 'Lead captured',
    'scan.invalidTitle': 'Invalid QR code',
    'scan.invalidUninterpretable': 'This QR code could not be interpreted as a FairVerify lead.',
    'scan.invalidUnprocessable': 'This QR code could not be processed.',
    'scan.fallbackActivatedTitle': 'Fallback enabled',
    'scan.fallbackActivatedText': 'The live scanner could not be started. The photo fallback will be used.',
    'scan.liveUnavailableTitle': 'Live scanner unavailable',
    'scan.noLoginTitle': 'No scan login active',
    'scan.noLoginText': 'Please choose an event and visitor ticket before scanning.',
    'scan.alreadyCapturedTitle': 'Already captured',
    'scan.alreadyCapturedText': 'This contact has already been captured.',
    'scan.mismatchFairTitle': 'Different event detected',
    'scan.mismatchFairSwitchText': 'The scanned code belongs to event {fairId}. The current scan login is {activeFairId}.',
    'scan.mismatchFairChooseTicketText': 'The scanned code belongs to event {fairId}. Please choose the correct ticket for that event now.',
    'scan.mismatchFairNoTicketText': 'The scanned code belongs to event {fairId}, but no matching visitor ticket was found for that event.',
    'scan.qrNotDetectedTitle': 'QR code not detected',
    'scan.notYetSynced': 'Not synchronized yet',
    'scan.boothLabel': 'Booth {stand}',
    'scan.scannedAt': 'Scanned: {date}',
    'actions.backToContacts': 'Back to contacts',
    'actions.changeTicket': 'Change ticket',
    'actions.cancel': 'Cancel',
    'actions.ok': 'OK',
    'actions.close': 'Close',
    'actions.continueScanning': 'Continue scanning',
    'actions.openContact': 'Open contact',
    'actions.syncNow': 'Sync now',
    'actions.switchAndCapture': 'Switch and capture',
    'actions.chooseTicket': 'Choose ticket',
    'actions.chooseEvent': 'Choose event',
    'actions.tryAgain': 'Try again',
    'actions.hideList': 'Hide list',
    'actions.showList': 'Show list',
    'actions.copyList': 'Copy list',
    'actions.unlock': 'Unlock',
    'list.leads': 'Leads',
    'list.sync': 'Sync',
    'list.allSynced': 'All synchronized',
    'list.emptyTitle': 'No scans yet',
    'list.emptyText': 'Switch to the scan tab and scan exhibitor or speaker tickets there.',
    'list.moreFairs': 'More events',
    'list.page': 'Page {page} of {total}',
    'list.previous': 'Previous',
    'list.next': 'Next',
    'list.unsyncedCount': '{count} unsynchronized',
    'settings.localDataTitle': 'Local data',
    'settings.localDataText': 'Delete saved contacts and pending sync information on this device.',
    'settings.resyncAll': 'Re-sync all scans',
    'settings.resetData': 'Reset app data',
    'settings.debugLogin': 'Debug: Scan login',
    'settings.invalidScansTitle': 'Invalid scans',
    'settings.invalidScansText': '{count} scanned codes could not be matched to a valid record.',
    'settings.fallbackTitle': 'Fallback scan',
    'settings.fallbackText': 'Optional photo fallback for cases where the live scanner does not work reliably on the local device.',
    'settings.fallbackAuto': 'Enable auto fallback',
    'settings.fallbackForced': 'Always use fallback',
    'settings.aboutTitle': 'About',
    'settings.aboutText': 'This scan feature is provided by FairVerify® Event Solutions GmbH.',
    'tabs.list': 'Contacts',
    'tabs.scan': 'Scan',
    'tabs.settings': 'Settings',
    'debug.unlockTitle': 'Unlock debug',
    'debug.unlockText': 'Please enter the debug password.',
    'debug.passwordPlaceholder': 'Password',
    'debug.invalidPassword': 'The password is not correct.',
    'debug.enabledTitle': 'Debug enabled',
    'debug.enabledText': 'Debug information is now visible in settings.',
    'debug.activeLoginSummary': 'Debug: Scan login',
    'fairSelector.title': 'Choose event',
    'fairSelector.close': 'Close',
    'ticket.noneFound': 'No matching tickets were found for this user.',
    'ticket.loadError': 'The current tickets could not be loaded.',
    'ticket.fallbackLabel': 'Ticket {barcode}',
    'storage.unavailableTitle': 'Local storage unavailable',
    'storage.unavailableText': 'Saved contacts and offline sync are currently not available on this device.',
    'storage.unavailableScanText': 'Scans cannot currently be saved locally on this device.',
    'storage.unavailableResyncText': 'Stored scans cannot currently be processed on this device.',
    'sync.failedTitle': 'Synchronization failed',
    'sync.failedText': 'The scan could not be synchronized.',
    'sync.invalidRecordTitle': 'No valid record',
    'sync.noScansTitle': 'No scans available',
    'sync.noScansText': 'There are currently no locally stored scans to re-sync.',
    'sync.offlineTitle': 'Offline',
    'sync.offlineText': 'A full re-sync is only possible while the device is online.',
    'sync.completedTitle': 'Re-sync completed',
    'sync.successTitle': 'Re-sync successful',
    'sync.completedText': '{syncedCount} scans updated, {failedCount} scans could not be synchronized.',
    'sync.completedTextWithInvalid': '{syncedCount} scans updated, {invalidCount} scans were moved to invalid, {failedCount} scans could not be synchronized.',
    'sync.successText': '{syncedCount} scans were updated successfully.',
    'sync.successTextWithInvalid': '{syncedCount} scans were updated successfully, {invalidCount} scans were moved to invalid.',
    'status.synced': 'synchronized',
    'status.failed': 'failed',
    'status.pending': 'pending',
    'copy.invalidScansTitle': 'List copied',
    'copy.invalidScansText': 'The list of invalid scans was copied to the clipboard.',
    'reset.confirm': 'Do you really want to reset local app data?',
    'reset.errorTitle': 'Reset failed',
    'reset.successTitle': 'App data deleted',
    'reset.successText': 'The local data was deleted successfully.',
    'scan.unsyncedInfo': 'Lead not synchronized yet, probably captured while offline.',
    'error.empty_code': 'The QR code is empty or invalid.',
    'error.invalid_leadscan_url_format': 'This QR code does not match the expected FairVerify lead format.',
    'error.invalid_leadscan_host': 'This QR code does not belong to a valid FairVerify lead.',
    'error.invalid_leadscan_payload_format': 'This QR code does not match the expected FairVerify lead format.',
    'error.inconsistent_fair_id': 'The QR code contains conflicting event information.',
    'error.invalid_code_prefix': 'This QR code does not belong to a valid FairVerify lead.',
    'error.invalid_code': 'This QR code is not supported.',
    'error.wrong_fair': 'The scanned code belongs to a different event.',
    'error.lead_not_found': 'No valid record was found for this QR code.',
    'error.invalid_visitor_type': 'This ticket type cannot currently be scanned here. At the moment only exhibitor scans are allowed.',
    'error.insufficient_scan_contingent': 'No scan contingent is available for this scan type.',
    'error.invalid_user_ticket_secret': 'The selected visitor ticket secret is invalid.',
    'error.invalid_user_uuid': 'The submitted user UUID is invalid for the selected ticket.',
    'error.invalid_user_ticket': 'The selected visitor ticket is invalid.',
    'error.invalid_user_ticket_context': 'The selected visitor ticket does not match the current event.',
    'error.invalid_user_order': 'The selected visitor order is invalid.',
    'error.invalid_user_account': 'The selected visitor account is invalid.',
    'error.visitor_not_found': 'The visitor ticket could not be resolved to a valid person.',
    'error.lead_scan_not_allowed': 'Lead scanning is not allowed for this event.',
    'error.missing_data': 'Required data is missing.',
    'error.method_not_allowed': 'Method not allowed.',
    'error.lead_save_failed': 'The lead could not be stored.',
    'error.invalid_fair': 'The selected event is invalid.',
    'error.camera_start_failed': 'The camera could not be started.',
    'error.camera_permission_denied': 'Camera access was denied.',
    'error.camera_not_found': 'No camera was found.',
    'error.camera_https_required': 'Camera access is only supported over HTTPS.',
    'error.camera_in_use': 'The camera is already used by another application.',
    'error.camera_unavailable': 'The requested camera is not available.',
    'error.camera_api_unsupported': 'Your browser does not support the camera API.',
    'error.fallback_unavailable': 'The fallback scanner is not available.',
    'error.fallback_decode_failed': 'The QR code could not be read from the photo.',
    'error.fallback_image_load_failed': 'The image could not be loaded.',
    'error.fallback_file_read_failed': 'The file could not be read.',
    'error.fallback_variant_failed': 'The image variant could not be created.'
  },
  de: {
    'view.title': 'Standbesuch erfassen',
    'common.loading': 'Lädt',
    'scan.activeLogin': 'Aktiver Scan-Login',
    'scan.switchCamera': 'Kamera wechseln',
    'scan.chooseLoginTitle': 'Scan-Login wählen',
    'scan.chooseLoginText': 'Wähle zuerst die Messe und das Besucherticket aus, für das Leads erfasst werden sollen.',
    'scan.takePhoto': 'Ticket fotografieren',
    'scan.captureHint': 'Apple erlaubt in installierten iOS-Web-Apps derzeit keinen stabilen Live-Scan. Deshalb wird ein Foto aufgenommen und lokal analysiert.',
    'scan.liveUnavailable': 'Der Live-Scanner konnte nicht gestartet werden.',
    'scan.noActiveLogin': 'Kein aktiver Scan-Login',
    'scan.unknownUser': 'Unbekannter Benutzer',
    'scan.noFair': 'Ohne Messe',
    'scan.offlineStoredTitle': 'Offline gespeichert',
    'scan.offlineStoredText': 'Der Kontakt wurde lokal gespeichert und wird später synchronisiert.',
    'scan.leadCapturedTitle': 'Lead erfasst',
    'scan.invalidTitle': 'Ungültiger QR-Code',
    'scan.invalidUninterpretable': 'Dieser QR-Code konnte nicht als FairVerify Lead interpretiert werden.',
    'scan.invalidUnprocessable': 'Dieser QR-Code konnte nicht verarbeitet werden.',
    'scan.fallbackActivatedTitle': 'Fallback aktiviert',
    'scan.fallbackActivatedText': 'Der Live-Scanner konnte nicht gestartet werden. Der Foto-Fallback wird verwendet.',
    'scan.liveUnavailableTitle': 'Live-Scanner nicht verfügbar',
    'scan.noLoginTitle': 'Kein Scan-Login aktiv',
    'scan.noLoginText': 'Bitte wähle zuerst eine Messe und ein Besucherticket für den Scan aus.',
    'scan.alreadyCapturedTitle': 'Bereits erfasst',
    'scan.alreadyCapturedText': 'Dieser Kontakt wurde bereits erfasst.',
    'scan.mismatchFairTitle': 'Andere Messe erkannt',
    'scan.mismatchFairSwitchText': 'Der gescannte Code gehört zur Messe {fairId}. Aktuell aktiv ist {activeFairId}.',
    'scan.mismatchFairChooseTicketText': 'Der gescannte Code gehört zur Messe {fairId}. Bitte wähle jetzt das passende Ticket für diese Messe aus.',
    'scan.mismatchFairNoTicketText': 'Der gescannte Code gehört zur Messe {fairId}, für die aktuell kein passendes Besucherticket gefunden wurde.',
    'scan.qrNotDetectedTitle': 'QR-Code nicht erkannt',
    'scan.notYetSynced': 'Noch nicht synchronisiert',
    'scan.boothLabel': 'Stand {stand}',
    'scan.scannedAt': 'Gescannt: {date}',
    'actions.backToContacts': 'Zurück zu Kontakte',
    'actions.changeTicket': 'Ticket wechseln',
    'actions.cancel': 'Abbrechen',
    'actions.ok': 'OK',
    'actions.close': 'Schließen',
    'actions.continueScanning': 'Weiter scannen',
    'actions.openContact': 'Zum Kontakt',
    'actions.syncNow': 'Jetzt syncen',
    'actions.switchAndCapture': 'Wechseln und erfassen',
    'actions.chooseTicket': 'Ticket auswählen',
    'actions.chooseEvent': 'Messe auswählen',
    'actions.tryAgain': 'Erneut versuchen',
    'actions.hideList': 'Liste ausblenden',
    'actions.showList': 'Liste anzeigen',
    'actions.copyList': 'Liste kopieren',
    'actions.unlock': 'Freischalten',
    'list.leads': 'Leads',
    'list.sync': 'Sync',
    'list.allSynced': 'Alle synchronisiert',
    'list.emptyTitle': 'Noch keine Scans vorhanden',
    'list.emptyText': 'Wechsle zum Tab "Scan" und scanne dort einfach Aussteller- oder Speaker-Tickets.',
    'list.moreFairs': 'Weitere Messen',
    'list.page': 'Seite {page} von {total}',
    'list.previous': 'Zurück',
    'list.next': 'Weiter',
    'list.unsyncedCount': '{count} unsynchronisiert',
    'settings.localDataTitle': 'Lokale Daten',
    'settings.localDataText': 'Gespeicherte Kontakte und offene Sync-Informationen auf diesem Gerät löschen.',
    'settings.resyncAll': 'Alle Scans neu synchronisieren',
    'settings.resetData': 'App-Daten zurücksetzen',
    'settings.debugLogin': 'Debug: Scan-Login',
    'settings.invalidScansTitle': 'Ungültige Scans',
    'settings.invalidScansText': '{count} gescannte Codes konnten keinem gültigen Datensatz zugeordnet werden.',
    'settings.fallbackTitle': 'Fallback-Scan',
    'settings.fallbackText': 'Optionaler Foto-Fallback für Fälle, in denen der Live-Scanner lokal nicht sauber läuft.',
    'settings.fallbackAuto': 'Auto-Fallback aktivieren',
    'settings.fallbackForced': 'Fallback dauerhaft aktivieren',
    'settings.aboutTitle': 'About',
    'settings.aboutText': 'Diese Scan-Funktion wird von FairVerify® Event Solutions GmbH bereitgestellt.',
    'tabs.list': 'Kontakte',
    'tabs.scan': 'Scan',
    'tabs.settings': 'Einstellungen',
    'debug.unlockTitle': 'Debug freischalten',
    'debug.unlockText': 'Bitte Debug-Passwort eingeben.',
    'debug.passwordPlaceholder': 'Passwort',
    'debug.invalidPassword': 'Das Passwort ist nicht korrekt.',
    'debug.enabledTitle': 'Debug aktiviert',
    'debug.enabledText': 'Die Debug-Informationen sind jetzt in den Einstellungen sichtbar.',
    'debug.activeLoginSummary': 'Debug: Scan-Login',
    'fairSelector.title': 'Messe auswählen',
    'fairSelector.close': 'Schließen',
    'ticket.noneFound': 'Für diesen Benutzer wurden aktuell keine passenden Tickets gefunden.',
    'ticket.loadError': 'Die aktuellen Tickets konnten nicht geladen werden.',
    'ticket.fallbackLabel': 'Ticket {barcode}',
    'storage.unavailableTitle': 'Lokaler Speicher nicht verfügbar',
    'storage.unavailableText': 'Gespeicherte Kontakte und Offline-Sync sind auf diesem Gerät aktuell nicht verfügbar.',
    'storage.unavailableScanText': 'Scans können auf diesem Gerät aktuell nicht lokal gespeichert werden.',
    'storage.unavailableResyncText': 'Gespeicherte Scans können auf diesem Gerät aktuell nicht verarbeitet werden.',
    'sync.failedTitle': 'Sync fehlgeschlagen',
    'sync.failedText': 'Der Scan konnte nicht synchronisiert werden.',
    'sync.invalidRecordTitle': 'Kein gültiger Datensatz',
    'sync.noScansTitle': 'Keine Scans vorhanden',
    'sync.noScansText': 'Es gibt aktuell keine lokal gespeicherten Scans zum Resynchronisieren.',
    'sync.offlineTitle': 'Offline',
    'sync.offlineText': 'Ein kompletter Resync ist nur möglich, wenn das Gerät online ist.',
    'sync.completedTitle': 'Resync abgeschlossen',
    'sync.successTitle': 'Resync erfolgreich',
    'sync.completedText': '{syncedCount} Scans aktualisiert, {failedCount} Scans konnten nicht synchronisiert werden.',
    'sync.completedTextWithInvalid': '{syncedCount} Scans aktualisiert, {invalidCount} Scans wurden in ungültige Scans verschoben, {failedCount} Scans konnten nicht synchronisiert werden.',
    'sync.successText': '{syncedCount} Scans wurden erfolgreich aktualisiert.',
    'sync.successTextWithInvalid': '{syncedCount} Scans wurden erfolgreich aktualisiert, {invalidCount} Scans wurden in ungültige Scans verschoben.',
    'status.synced': 'synchronisiert',
    'status.failed': 'fehlgeschlagen',
    'status.pending': 'offen',
    'copy.invalidScansTitle': 'Liste kopiert',
    'copy.invalidScansText': 'Die Liste der ungültigen Scans wurde in die Zwischenablage kopiert.',
    'reset.confirm': 'Lokale App-Daten wirklich zurücksetzen?',
    'reset.errorTitle': 'Zurücksetzen fehlgeschlagen',
    'reset.successTitle': 'App-Daten gelöscht',
    'reset.successText': 'Die lokalen Daten wurden erfolgreich gelöscht.',
    'scan.unsyncedInfo': 'Lead noch nicht synchronisiert, vermutlich offline erfasst.',
    'error.empty_code': 'Der QR-Code ist leer oder ungültig.',
    'error.invalid_leadscan_url_format': 'Dieser QR-Code entspricht nicht dem erwarteten FairVerify-Lead-Format.',
    'error.invalid_leadscan_host': 'Dieser QR-Code gehört nicht zu einem gültigen FairVerify Lead.',
    'error.invalid_leadscan_payload_format': 'Dieser QR-Code entspricht nicht dem erwarteten FairVerify-Lead-Format.',
    'error.inconsistent_fair_id': 'Der QR-Code enthält widersprüchliche Messe-Informationen.',
    'error.invalid_code_prefix': 'Dieser QR-Code gehört nicht zu einem gültigen FairVerify Lead.',
    'error.invalid_code': 'Dieser QR-Code wird nicht unterstützt.',
    'error.wrong_fair': 'Der gescannte Code gehört zu einer anderen Messe.',
    'error.lead_not_found': 'Zu diesem QR-Code wurde kein gültiger Datensatz gefunden.',
    'error.invalid_visitor_type': 'Dieser Tickettyp kann hier aktuell nicht gescannt werden. Zurzeit sind nur Aussteller-Scans erlaubt.',
    'error.insufficient_scan_contingent': 'Für diesen Scan-Typ ist kein Scan-Kontingent mehr verfügbar.',
    'error.invalid_user_ticket_secret': 'Das ausgewählte Besucherticket-Secret ist ungültig.',
    'error.invalid_user_uuid': 'Die übermittelte User-UUID ist für das ausgewählte Ticket ungültig.',
    'error.invalid_user_ticket': 'Das ausgewählte Besucherticket ist ungültig.',
    'error.invalid_user_ticket_context': 'Das ausgewählte Besucherticket passt nicht zur aktuellen Messe.',
    'error.invalid_user_order': 'Die ausgewählte Besucherbestellung ist ungültig.',
    'error.invalid_user_account': 'Das ausgewählte Besucherkonto ist ungültig.',
    'error.visitor_not_found': 'Das Besucherticket konnte keiner gültigen Person zugeordnet werden.',
    'error.lead_scan_not_allowed': 'Lead-Scanning ist für diese Messe nicht erlaubt.',
    'error.missing_data': 'Pflichtdaten fehlen.',
    'error.method_not_allowed': 'Methode nicht erlaubt.',
    'error.lead_save_failed': 'Der Lead konnte nicht gespeichert werden.',
    'error.invalid_fair': 'Die ausgewählte Messe ist ungültig.',
    'error.camera_start_failed': 'Die Kamera konnte nicht gestartet werden.',
    'error.camera_permission_denied': 'Der Kamerazugriff wurde verweigert.',
    'error.camera_not_found': 'Keine Kamera gefunden.',
    'error.camera_https_required': 'Kamerazugriff wird nur über HTTPS unterstützt.',
    'error.camera_in_use': 'Die Kamera wird bereits von einer anderen Anwendung verwendet.',
    'error.camera_unavailable': 'Die angeforderte Kamera ist nicht verfügbar.',
    'error.camera_api_unsupported': 'Dein Browser unterstützt die Kamera-API nicht.',
    'error.fallback_unavailable': 'Der Fallback-Scanner ist nicht verfügbar.',
    'error.fallback_decode_failed': 'Der QR-Code konnte aus dem Foto nicht gelesen werden.',
    'error.fallback_image_load_failed': 'Das Bild konnte nicht geladen werden.',
    'error.fallback_file_read_failed': 'Die Datei konnte nicht gelesen werden.',
    'error.fallback_variant_failed': 'Die Bildvariante konnte nicht erzeugt werden.'
  }
}

export function getVisitorLeadLocale() {
  const locale = String(document?.documentElement?.lang || navigator.language || 'en').toLowerCase()
  return locale.startsWith('de') ? 'de' : 'en'
}

export function translateVisitorLead(key, replacements = {}, locale = getVisitorLeadLocale()) {
  const dictionary = translations[locale] || translations.en
  const fallbackDictionary = translations.en
  let text = dictionary[key] || fallbackDictionary[key] || key

  Object.entries(replacements).forEach(([replacementKey, replacementValue]) => {
    text = text.replaceAll(`{${replacementKey}}`, String(replacementValue))
  })

  return text
}

export function translateVisitorLeadError(code, fallbackMessage = '', locale = getVisitorLeadLocale(), replacements = {}) {
  if (code) {
    const key = `error.${code}`
    const translated = translateVisitorLead(key, replacements, locale)
    if (translated !== key) {
      return translated
    }
  }

  return fallbackMessage || translateVisitorLead('sync.failedText', replacements, locale)
}
